<!-- 
    Template: 
      <confirm-dialog ref="ConfirmDialog"></confirm-dialog>

    Call method:
      var result = await this.$store.dispatch("ConfirmDialog/Show");
      if (result) {}
-->
<template>
  <v-dialog v-model="show" :persistent="Properties.persistent" max-width="360">
    <v-card>
      <dialog-header :title="Properties.title" :closable="false" :expandable="false">
      </dialog-header>

      <v-card-text class="px-5 pt-1 black--text">
        {{ Properties.message }}
        <v-checkbox v-if="dontRemindMeKey" v-model="checkbox"
          :label="$t('servicesystem.common_objects.commonterms.dont_remind_me')" class="mt-0" style="margin-left: -2px;"
          hide-details></v-checkbox>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn @click="cancel()" class="" :color="Properties.cancelbutton.color"
          :outlined="Properties.cancelbutton.outlined">
          {{ Properties.cancelbutton.text }}
        </v-btn>
        <v-btn v-if="Properties.conditionalconfirmbutton" @click="conditionalconfirm()"
          :color="Properties.conditionalconfirmbutton.color" :outlined="Properties.conditionalconfirmbutton.outlined">
          {{ Properties.conditionalconfirmbutton.text }}
        </v-btn>
        <v-btn @click="confirm()" :color="Properties.confirmbutton.color" :outlined="Properties.confirmbutton.outlined">
          {{ Properties.confirmbutton.text }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import DialogHeader from "@/components/Dialogs/Dialog parts/DialogHeader.vue";

export default {
  name: "ConfirmDialog",
  components: { DialogHeader },

  data() {
    return {
      checkbox: false,
    };
  },

  mounted() { },

  methods: {
    confirm() {
      if (this.checkbox) { this.dontRemindMe = true; }
      this.$store.dispatch("ConfirmDialog/Confirm");
    },
    conditionalconfirm() {
      this.$store.dispatch("ConfirmDialog/ConditionalConfirm");
    },
    cancel() {
      this.$store.dispatch("ConfirmDialog/Cancel");
    },
  },

  computed: {
    Properties() {
      return this.$store.getters["ConfirmDialog/Properties"];
    },

    show: {
      get() {
        return this.Properties?.displayDialog;
      },
      set() {
        console.log('confirmdialog close');
      },
    },

    dontRemindMeKey() {
      return this.Properties?.dontRemindMeKey;
    },

    dontRemindMe: {
      get() {
        var res = this.$store.getters["prefrences/Prefrence"](this.dontRemindMeKey);
        return res && res != 'UNKNOWN_PREFRENCE';
      },
      set(update) {
        this.$store.dispatch("prefrences/set_prefrence", { key: this.dontRemindMeKey, value: update });
      },
    },
  },

  watch: {
    show: function () {
      if (this.dontRemindMeKey && this.dontRemindMe) {
        this.confirm();
      }
    },
  },
};
</script>